module.exports = " <i :class=classes :style=styles></i> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/standard/components/icon/icon.vue
// module id = 295
// module chunks = 0